import { ex } from '@fullcalendar/core/internal-common';

import * as yup from 'yup';

export interface IDepartment {
    id: number;
    departmentName: string;
}


export interface IAddDesignation {
    departmentId?: number;
    designation: string;
}

export const emptyAddDesignation: IAddDesignation = {
    departmentId: 0,
    designation: '',
}

export const schema = yup.object().shape({
    designation: yup.string().required('Designation required'),
});